import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'common/components';
import { decode } from 'js-base64';
import { selectPageModelCategoryText } from 'store/pageModel';
import { AdditionalTextContainer, textStyles } from './styled';

export const AdditionalText = () => {
	const categoryText = useSelector(selectPageModelCategoryText);

	if (!categoryText) {
		return null;
	}

	return (
		<AdditionalTextContainer data-qa="additional-text-container">
			<Container
				className={textStyles}
				dangerouslySetInnerHTML={{ __html: decode(categoryText) }}
			/>
		</AdditionalTextContainer>
	);
};
